export const PROPERTY_TYPE__DATE = 'date';
export const PROPERTY_TYPE__USER_ID = 'userId';
export const PROPERTY_TYPE__STRING = 'string';
